import { NotContainsNumberError } from '../../validation/errors/not-contains-number-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class ContainsNumberValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    if (value.length === 0) return null
    if (!value.match(/[0-9]/g)) return new NotContainsNumberError()
    return null
  }
}
